import { AfterContentChecked, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { PlanejamentoOficina } from '../../../core/planejamento-oficina';

@Component({
  selector: 'material-planejamento-oficina',
  templateUrl: './material-planejamento-oficina.component.html',
  styleUrls: ['./material-planejamento-oficina.component.css']
})
export class MaterialPlanejamentoOficinaComponent implements OnInit, AfterContentChecked {

  @Input() planejamentoOficina: PlanejamentoOficina;

  openFormCadastro = false;

  constructor(protected drc: ChangeDetectorRef) {
  }

  ngOnInit() {
  }

  ngAfterContentChecked(): void {
    this.drc.detectChanges();
  }


  onGetAdicionar(evento) {
    this.openFormCadastro = evento;
  }

}
